import {Box, Button, Typography} from "@mui/material";
import { css } from "aphrodite";
import styles from "./styles";
import StepDataInfo from "../StepDataInfo/StepDataInfo";
import {useNavigate} from "react-router";
import {RoutePath} from "../../../../Utils/routePath";


const CommonLayoutTitle = ({ 
    statusTitle,
    statusSubtitle,
    title,
    iconSrc,
    description,
    stepDataLayoutVisible = false,
    appointmentData = null,
    titleClassName = '',
    onStatusTitleClick = null,
}) => {

    const navigate = useNavigate();

    const handleGoHome = () => {
        if (onStatusTitleClick) {
            onStatusTitleClick();
        } else {
            navigate(RoutePath.appointmentPage);
        }
    };
    
    return (
        <div className={css(styles.container)}>
        {/* Steps or Status */}
            <div className={css(styles.stepsContainer)}>
                <Button
                    variant="text"
                    color={"primary"}
                    onClick={handleGoHome}
                    disableElevation
                    disableRipple
                    style={{
                        padding: 0,
                        textTransform: "none",
                        minWidth: "auto",
                        whiteSpace: "nowrap",
                    }}
                >
                    <Typography variant="h5" component="span" color="primary">
                        {statusTitle}
                    </Typography>
                </Button>
                {
                    statusSubtitle && (
                        <Typography variant="h5" component="span" color="secondary">
                            {" "}
                            &nbsp;/&nbsp;
                            {" "}
                            {statusSubtitle}
                        </Typography>
                    )
                }
            </div>
            {!appointmentData && <Box sx={{margin: "30px 0px"}}/>}
            <div className={css(styles.titleRow)}>
                <img alt="" src={iconSrc} />
                <Typography variant="h4" component="h1" className={titleClassName}>{title}</Typography>
            </div>
            {stepDataLayoutVisible && <StepDataInfo appointmentData={appointmentData} />}
            {
                description && (
                    <Typography
                        variant="body1"
                        component="p"
                        color="inherit"
                        sx={{ marginTop: "26px" }}
                    >
                        {description}
                    </Typography>
                )
            }
    </div>
    );
}   

export default CommonLayoutTitle;   
